export class TokenResponseModel {
  Token: string;
  CaptchaKey :string;
  CaptchaImage :string;
  ErrorType: string;
  AuthenticationType: string;
}
